import { useStyletron } from "baseui";
import React from "react";
import BrowserImage from "../../assets/images/isometric-browser-window.svg";
import CodeImage from "../../assets/images/isometric-code-icon.svg";
import type { DocsInterfaceProps } from "../../src/chrome/DocsInterface";
import { DocsInterface } from "../../src/chrome/DocsInterface";
import Landing from "../../src/components/Landing";
import { SplashCard, SplashCardGrid, colors } from "../../src/components/SplashPage";

const GuidesPage = (props: DocsInterfaceProps) => {
  const [css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <Landing
        title="Learn how to build with Gadget"
        contents={[
          "Learn the fundamentals of the Gadget framework with our guides. The guides will teach you core Gadget concepts, and show you how you can compose them to build full-stack web apps.",
        ]}
      >
        <SplashCardGrid $maxColumns={1} className={css({ marginTop: $theme.sizing.scale1200 })}>
          <SplashCard
            color={colors.yellow}
            title="Quickstart"
            body="Get started in Gadget and build a sample application."
            copy="Build an app →"
            href="/guides/getting-started/quickstarts/web-quickstart"
            featureImage={<img src={CodeImage} width="185px" height="115px" />}
          />
          <SplashCard
            color={colors.electricBlue}
            title="Tutorials"
            body="Learn how to build through a series of interactive tutorials."
            copy="Learn more →"
            href="/guides/tutorials"
            featureImage={<img src={BrowserImage} width="100px" height="100px" style={{ marginRight: "24px" }} />}
          />
        </SplashCardGrid>
      </Landing>
    </DocsInterface>
  );
};

export default GuidesPage;
